module.exports = __webpack_public_path__ + "static/img/男装.584e1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/男装.png
// module id = Ae3P
// module chunks = 13